import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Thanks.css";

export default function Thanks() {
  return (
    <div className="thanks-page">
      <div id="page-top" />
      <Container>
        <h1>ご応募ありがとうございます！</h1>
        <p>内容を受け付けました。担当者よりご連絡いたします。</p>
        <Button as={Link} to="/entry#page-top" variant="primary" size="lg">
          エントリーフォームへ戻る
        </Button>
      </Container>
    </div>
  );
}
